module.exports = __webpack_public_path__ + "static/media/john_potter.63193334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/john_potter.jpg
// module id = 210
// module chunks = 0